import { render } from "./Stripe.vue?vue&type=template&id=52c63e84"
import script from "./Stripe.vue?vue&type=script&lang=js"
export * from "./Stripe.vue?vue&type=script&lang=js"
script.render = render

export default script